import {
    collection,
    doc,
    getDoc,
    documentId,
    orderBy,
    query,
    runTransaction,
    serverTimestamp,
    where
} from "firebase/firestore";
import { DateTime } from "luxon";
import { maxCapacity } from "../App";
import db from "./firebase";


const checkins = collection(db, "checkins");
const users = collection(db, "users");

const user = (userId) => 
  // console.log('userId', userId)
   doc(db, "users", userId)


const getUser = (userId) =>
  getDoc(user(userId))
    .then((u) => {
      // console.log('u', u.data());
      if (u.exists()) return u.data();
      return {}
    })
    .catch((e) => {
      console.log(e);
      return {};
    });

const mappeduser = (id) => doc(db, "mappedusers", id)

const getAll = () => users;

const getRegisteredCheckedInUsers = (timestamp) => query(
  collection(db, "users", ),
  orderBy('checkedIn'),
  // where('type', "!=", null),
  where('checkedIn', ">=", DateTime.fromMillis(Number(timestamp)).toJSDate())
) ;

const getAllRegisteredUsers = () => query(
  collection(db, "users", ),
  orderBy('type'),
  where('type', "!=", null),
  // where('checkedIn', ">=", DateTime.fromMillis(Number(timestamp)).toJSDate())
) ;

const updateUserProfile = async (data) => {
  const { user } = data
  // console.log('timestamp',timestamp);
  console.log('user',user);

    try {
      const saveUserRequest = await runTransaction(db, async (transaction) => {
        // const countDocRef = doc(db, "checkinCounts", timestamp)
        const userDocRef = doc(db, "users", user.userId)

        // const count = await transaction.get(countDocRef);
        const dbUser = await transaction.get(userDocRef);
        // if (!count.exists || (count.exists && count.data() && !count.data().count) || count.data().count  < maxCapacity) {

          if (dbUser.exists()) {
            transaction.update(userDocRef, {
              ...user,
              updated: serverTimestamp()
            })
          } else {
            transaction.set(userDocRef, {
              ...user,
              updated: serverTimestamp()
          })
        }
        return 1

      });
      console.log("Transaction successfully committed!");
      return saveUserRequest

    } catch (e) {
      console.log("Transaction failed: ", e);
      return e
    }
};



const getOfHour = (timestamp) => collection(db, "checkins", timestamp, "users");

const getCountOfHour = (timestamp) => doc(db, "checkinCounts", timestamp);

const getCountOfDay = (timestamp) => query(
  collection(db, "checkinCounts", ),
  orderBy(documentId()),
  where(documentId(), ">=", timestamp),
  where(documentId(), ">=", timestamp)
) ;

const getMessageOfDay = (timestamp) =>
  // console.log('timestamp', timestamp);
   doc(db, "messageoftheday", timestamp)

const createWalkinRequest = async (data) => {
  const { timestamp, user } = data
  console.log('timestamp',timestamp);
  console.log('user',user);

  // const countDocRef = doc(db, "checkinCounts", timestamp)
  //     const userDocRef = doc(db, "users", user.id)

      // try {

      //   const count = query(getCountOfHour(timestamp))

      //   // if (count && count < 30) {
      //     await users.doc(user.id).update({
      //       ok: true
      //     })
      //     return timestamp
      //   // }
      //   // return 0
      // } catch (error) {
      //   return error
      // }
      // const dbUser = await transaction.get(userDocRef);
  //     if (!count.exists || (count.exists && count.data() && count.data().count < 300)) {

  //     }
    try {
      const walkinrequest = await runTransaction(db, async (transaction) => {
        // const countDocRef = doc(db, "checkinCounts", timestamp)
        const userDocRef = doc(db, "users", user.id)


        // const count = await transaction.get(countDocRef);
        const dbUser = await transaction.get(userDocRef);
        // if (!count.exists || (count.exists && count.data() && !count.data().count) || count.data().count  < maxCapacity) {
          if (dbUser.exists) {
            transaction.update(userDocRef, {
              requestedWalkin: true,
              queue: timestamp
            })
          } else {
            transaction.set(userDocRef, {
              requestedWalkin: true
            })

          }
          return 1
        // }
        // return 0

      });
      console.log("Transaction successfully committed!");
      return walkinrequest

    } catch (e) {
      console.log("Transaction failed: ", e);
      return e
    }



};


const create = (data) => checkins.add(data);

const update = (id, value) => checkins.doc(id).update(value);

const remove = (id) => checkins.doc(id).delete();

const UserService = {
  user,
  getUser,
  mappeduser,
  updateUserProfile,
  getAll,
  getAllRegisteredUsers,
  getRegisteredCheckedInUsers,
  getOfHour,
  getCountOfHour,
  getCountOfDay,
  getMessageOfDay,
  create,
  createWalkinRequest,
  update,
  remove
};

export default UserService;